import { Link } from "react-router-dom";
import servicesThreeData from "./servicesThreeData";

const ServicesThree = () => {
    return (
        <section className="our-services-box-wrapper section-padding bg-gray">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-8 mb-4 offset-xl-3 offset-lg-2 col-12 text-center">
                        <div className="section-title-3">
                            <h6>Our Services</h6>
                            <h2>QUICK SERVICES</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {
                        servicesThreeData.map((data) => (
                            <div className="col-xl-4 col-md-6 d-flex mb-4" key={data.id}>
                                <div className="single-services-box sb1">
                                    <div className="icon">
                                        <img src={data.img} alt={data.title} loading="lazy" width="64" height="64" />
                                    </div>
                                    <div className="content">
                                        <h3><Link to="#">{data.title}</Link></h3>
                                        <p>{data.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

                {/* Services CTA Section */}
                <div className="row mt-2">
                    <div className="col-12">
                        <div className="services-cta-banner">
                            <div className="services-cta-content">
                                <h3 className="services-cta-heading">
                                    Looking for any of these services?
                                </h3>
                                <ul className="services-cta-list">
                                    <li>
                                        <span className="cta-check">✔</span>
                                        Need office or villa renovation? We handle everything
                                    </li>
                                    <li>
                                        <span className="cta-check">✔</span>
                                        Electrical or plumbing issues? Expert technicians available
                                    </li>
                                    <li>
                                        <span className="cta-check">✔</span>
                                        Want yearly maintenance? Affordable AMC packages
                                    </li>
                                </ul>
                            </div>
                            <div className="services-cta-action">
                                
                                 <a
                        className="theme-btn services-cta-btn"
                        href="https://wa.me/971502033924"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Get a Free Inspection Today
                    </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ServicesThree;